import { ReactNode } from "react";
import { Box } from "@mui/material";

//Common styles
import {
  TableTopHeader,
  TableWrapper,
  Title,
} from "../../styles/commonStyles";
import { colors } from "../../styles/colors";

/**
 * sx to pass to a react-admin <Datagrid> so it matches the CommonListTable /
 * SOS Alerts look exactly — same header colors, font weight, cell padding,
 * row borders and hover as the TableHeader / TableData / CustomTableRowTR
 * styled components in commonStyles.
 */
export const commonDatagridSx = {
  // The light theme paints RaDatagrid grey (#eeeeee) globally — force the
  // white card background the CommonListTable pages use
  background: colors.light.bgWhite,
  "& .RaDatagrid-tableWrapper": {
    overflowX: "auto",
  },
  "& .RaDatagrid-headerCell": {
    backgroundColor: "rgba(232, 235, 237, 0.3)",
    textAlign: "left",
    fontWeight: 500,
    fontSize: "14px",
    color: colors.light.tableHeader,
    padding: "12px 16px",
    whiteSpace: "nowrap",
    // Sortable column labels keep the same header color instead of the
    // default sort-link styling
    "& .MuiTableSortLabel-root, & .MuiTableSortLabel-root.Mui-active": {
      color: colors.light.tableHeader,
      fontWeight: 500,
    },
  },
  "& .RaDatagrid-rowCell": {
    padding: "12px 16px",
    fontSize: "14px",
    whiteSpace: "nowrap",
    borderBottom: `1px solid ${colors.light.tableBorder}`,
  },
  "& .RaDatagrid-row": {
    transition: "background-color 0.2s ease-in-out",
  },
  "& .RaDatagrid-row:hover": {
    backgroundColor: colors.light.tableBgHover,
    cursor: "pointer",
  },
};

/**
 * Card shell (title bar + rounded container) around a react-admin
 * <Datagrid>, matching the CommonListTable design.
 */
const StyledDatagridWrapper = ({
  title,
  headerRight,
  children,
}: {
  title: string;
  headerRight?: ReactNode;
  children: ReactNode;
}) => (
  <TableWrapper>
    <TableTopHeader>
      <Title>{title}</Title>
      {headerRight}
    </TableTopHeader>
    {/* Rounded inner container so the datagrid reads as a card,
        matching the CommonListTable look */}
    <Box
      sx={{
        margin: { xs: "0 8px 12px", sm: "0 16px 16px" },
        borderRadius: "8px",
        // auto (not hidden) so wide tables scroll horizontally inside the card
        overflow: "auto",
        boxShadow:
          "0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)",
      }}
    >
      {children}
    </Box>
  </TableWrapper>
);

export default StyledDatagridWrapper;
